var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _startPos, _endPos, _a, _gravity, _startT, _endT, _startPos_1, _endPos_1, _startVelo, _endVelo;
import { Vec3D } from "./vec3d";
export class TossPath {
    constructor(gravity, startT, startPos, endT, endPos) {
        _startPos.set(this, void 0);
        _endPos.set(this, void 0);
        _a.set(this, 0);
        _gravity.set(this, void 0);
        __classPrivateFieldSet(this, _gravity, gravity);
        this.startT = startT;
        __classPrivateFieldSet(this, _startPos, startPos);
        this.endT = endT;
        __classPrivateFieldSet(this, _endPos, endPos);
        // f(x) = -9.8x^2 + a x + b;
        //
        // f(0)=b
        // f(t)=c
        //
        //
        // -9.8t^2 + at + b = c
        // at + b = c + 9.8t^2
        // at = c + 9.8t^2 - b
        // a = (c + 9.8t^2 - b)/t
        const deltaT = endT - startT;
        __classPrivateFieldSet(this, _a, (endPos.y + __classPrivateFieldGet(this, _gravity) * deltaT * deltaT - startPos.y) / deltaT);
    }
    containsT(t) {
        return t >= this.startT && t < this.endT;
    }
    posAt(t) {
        const deltaT = this.endT - this.startT;
        const deltaPos = __classPrivateFieldGet(this, _endPos).sub(__classPrivateFieldGet(this, _startPos));
        let p = (t - this.startT) / deltaT;
        let pos = __classPrivateFieldGet(this, _startPos).add(deltaPos.mul(p));
        // f(x) = -9.8x^2 + a x + b;
        //
        // f(0)=b
        // f(t)=c
        //
        //
        // -9.8t^2 + at + b = c
        // at + b = c + 9.8t^2
        // at = c + 9.8t^2 - b
        // a = (c + 9.8t^2 - b)/t
        const pt = t - this.startT;
        pos.y = -__classPrivateFieldGet(this, _gravity) * pt * pt + __classPrivateFieldGet(this, _a) * pt + __classPrivateFieldGet(this, _startPos).y;
        return pos;
    }
    velocityAt(t) {
        // pos(t) = -g * (t-st)^2 + ((ep + g * (et-st)^2 - sp)/(et-st)) * (t-st) + sp
        // pos0(t) = -g * (t)^2 + ((ep + g * (et-st)^2 - sp)/(et-st)) * t + sp
        // pos0'(t) = -2gt + ((ep + g * (et-st)^2 - sp)/(et-st))
        const pt = t - this.startT;
        const velo = new Vec3D(0, -2 * __classPrivateFieldGet(this, _gravity) * pt + __classPrivateFieldGet(this, _a), 0);
        const deltaPos = __classPrivateFieldGet(this, _endPos).sub(__classPrivateFieldGet(this, _startPos));
        const deltaT = this.endT - this.startT;
        velo.x += deltaPos.x / deltaT;
        velo.y += deltaPos.y / deltaT;
        velo.z += deltaPos.z / deltaT;
        return velo;
    }
}
_startPos = new WeakMap(), _endPos = new WeakMap(), _a = new WeakMap(), _gravity = new WeakMap();
// Trajectory Generation via Spline Cubic Polynomial
// Robotics_TrajectoryGeneration.pdf
export class HandSpline {
    constructor(startT, startPos, startVelo, endT, endPos, endVelo) {
        _startT.set(this, void 0);
        _endT.set(this, void 0);
        _startPos_1.set(this, void 0);
        _endPos_1.set(this, void 0);
        _startVelo.set(this, void 0);
        _endVelo.set(this, void 0);
        __classPrivateFieldSet(this, _startT, startT);
        __classPrivateFieldSet(this, _endT, endT);
        __classPrivateFieldSet(this, _startPos_1, startPos);
        __classPrivateFieldSet(this, _endPos_1, endPos);
        __classPrivateFieldSet(this, _startVelo, startVelo);
        __classPrivateFieldSet(this, _endVelo, endVelo);
    }
    posAt(t) {
        // a = pos at startT
        // b = velo at starT
        // c = pos at endT
        // d = velo at endT
        const ret = new Vec3D();
        t -= __classPrivateFieldGet(this, _startT);
        const tf = __classPrivateFieldGet(this, _endT) - __classPrivateFieldGet(this, _startT);
        for (let i = 0; i < 3; i++) {
            let a = __classPrivateFieldGet(this, _startPos_1).dimValue(i);
            let b = __classPrivateFieldGet(this, _startVelo).dimValue(i);
            let c = __classPrivateFieldGet(this, _endPos_1).dimValue(i);
            let d = __classPrivateFieldGet(this, _endVelo).dimValue(i);
            let p = a +
                b * t +
                ((3 * (c - a) - tf * (2 * b + d)) * t * t) / (tf * tf) +
                ((2 * (a - c) + tf * (b + d)) * t * t * t) / (tf * tf * tf);
            ret.setDimValue(i, p);
        }
        return ret;
    }
}
_startT = new WeakMap(), _endT = new WeakMap(), _startPos_1 = new WeakMap(), _endPos_1 = new WeakMap(), _startVelo = new WeakMap(), _endVelo = new WeakMap();
